module.exports = __webpack_public_path__ + "static/media/51_Print.f34aa80c.png";